export default [
  {
    path: '/h5/fans_rule',
    component: () => import('./Page.vue'),
    meta: {
      title: '粉丝团规则',
    },
  },
]
